<ion-item-divider
  mode="ios"
  *ngIf="noOnlinePayNoPickupPromos && noOnlinePayNoPickupPromos.length > 0"
>
  <ion-label>
    <strong>{{
      "cart.cart-components.checkbox-promotions.promotions" | translate
    }}</strong>
  </ion-label>
</ion-item-divider>

<div *ngIf="checkboxPromotions && checkboxPromotions.length > 0">
  <div
    *ngFor="
      let promo of checkboxPromotions | noOnlinePaymentNoPickupOnly;
      trackBy: trackbyFnc
    "
  >
    <ion-item>
      <ion-label class="ion-text-wrap"
        >{{ promo.descriptionCheckbox }}
        <p class="cartWarningColor" *ngIf="promo.couponSelected">
          {{
            "cart.cart-components.checkbox-promotions.promotions-cannot-be-combined-with-the-selected-coupons"
              | translate
          }}
        </p></ion-label
      >
      <ion-checkbox
        [disabled]="promo.couponSelected || finalPriceLoading"
        slot="start"
        [(ngModel)]="promo.promoCheckbox"
        (ionChange)="clickCheckboxPromotion(promo)"
      ></ion-checkbox>
    </ion-item>

    <div
      class="custom-discount-editor"
      *ngIf="promo.custom_discount && promo.promoCheckbox"
    >
      <div class="custom-discount-controls">
        <ion-segment
          mode="ios"
          [disabled]="finalPriceLoading"
          [ngModel]="promo.discountType"
          (ngModelChange)="changeCustomDiscountType(promo, $event)"
        >
          <ion-segment-button value="percent">
            {{
              "cart.cart-components.checkbox-promotions.custom-discount-percent"
                | translate
            }} %
          </ion-segment-button>
          <ion-segment-button value="fixed">
            {{
              "cart.cart-components.checkbox-promotions.custom-discount-fixed"
                | translate
            }}
          </ion-segment-button>
        </ion-segment>

        <div class="custom-discount-actions">
          <div
            class="custom-discount-presets"
            *ngIf="promo.discountType === 'percent'"
          >
            <ion-button
              *ngFor="let preset of percentPresetValues"
              mode="ios"
              size="small"
              [disabled]="finalPriceLoading"
              [fill]="promo.discountPercentage === preset ? 'solid' : 'outline'"
              (click)="selectCustomDiscountPreset(promo, preset)"
            >
              {{ preset }}%
            </ion-button>
          </div>

          <div
            class="custom-discount-stepper-wrap"
            *ngIf="promo.discountType === 'percent'"
          >
            <div class="custom-discount-stepper">
              <ion-button
                mode="ios"
                size="small"
                fill="outline"
                [disabled]="
                  finalPriceLoading ||
                  (promo.discountPercentage !== null &&
                    promo.discountPercentage <= percentMinValue)
                "
                (click)="stepCustomDiscountValue(promo, -1)"
              >
                -
              </ion-button>

              <div class="custom-discount-stepper-value">
                <span
                  *ngIf="
                    promo.discountType === 'percent' &&
                    promo.discountPercentage !== null
                  "
                >
                  {{ promo.discountPercentage }}%
                </span>
                <span
                  *ngIf="
                    promo.discountType === 'fixed' && promo.fixedAmount !== null
                  "
                >
                  {{ promo.fixedAmount | number : "1.1-1" }}€
                </span>
                <span
                  *ngIf="
                    (promo.discountType === 'percent' &&
                      promo.discountPercentage === null) ||
                    (promo.discountType === 'fixed' &&
                      promo.fixedAmount === null)
                  "
                >
                  {{ "please-select" | translate }}
                </span>
              </div>

              <ion-button
                mode="ios"
                size="small"
                fill="outline"
                [disabled]="
                  finalPriceLoading ||
                  (promo.discountPercentage !== null &&
                    promo.discountPercentage >= percentMaxValue)
                "
                (click)="stepCustomDiscountValue(promo, 1)"
              >
                +
              </ion-button>
            </div>
          </div>

          <div
            class="custom-discount-stepper-wrap custom-discount-fixed-input-wrap"
            *ngIf="promo.discountType === 'fixed'"
          >
            <div class="custom-discount-stepper-value">
              <ion-input
                class="ion-text-center"
                type="number"
                debounce="1200"
                [(ngModel)]="promo.fixedAmount"
                (ionChange)="updateCustomDiscountFixedValue(promo, promo.fixedAmount)"
                inputmode="decimal"
                [min]="fixedMinValue"
                [max]="fixedDiscountMaxValue"
                step="0.1"
                [placeholder]="'write-here' | translate"
                [disabled]="
                  finalPriceLoading ||
                  fixedDiscountMaxValue === null ||
                  fixedDiscountMaxValue < fixedMinValue
                "
              ></ion-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
